export default {
  'tours.heroEyebrow': 'Explore Vietnam',
  'tours.heroTitle': 'Tour Packages',
  'tours.heroSubtitle': "Handcrafted journeys across Vietnam, from the misty north to the sunny south — pick a starting point and we'll shape it into your own trip.",
  'tours.breadcrumbHome': 'Home',
  'tours.gridTitle': 'Tour Packages',
  'tours.searchPlaceholder': 'Search by tour name',
  'tours.styleAll': 'Your style: All',
  'tours.styleMobileAll': 'Style: All',
  'tours.styleMultiDay': 'Multi-day',
  'tours.styleDayTour': 'Day Tour',
  'tours.styleCruise': 'Cruise',
  'tours.durationAll': 'Duration: All',
  'tours.days1to3': '1-3 Days',
  'tours.days4to7': '4-7 Days',
  'tours.days8plus': '8+ Days',
  'tours.noMatch': 'No tours match your filters. Try adjusting your search.',
  'tours.spots': '{{count}} Spots',
  'tours.from': 'From',
  'tours.view': 'View',
  'tours.addWishlist': 'Add to wishlist',
  'tours.prevPage': 'Previous page',
  'tours.nextPage': 'Next page',
  'tours.pagination': 'Pagination',
  'destinations.title': 'Where is your favorite place?',
  'destinations.error': "Couldn't load destinations.",
  'destinations.tryAgain': 'Try again',
  'intro.text': 'Rapidly becoming the most sought-after destination in Southeast Asia, Vietnam captivates every traveler. Whether your heart seeks rugged adventure, rich cultural discovery, world-class culinary experiences, or the ultimate in luxury relaxation, Vietnam offers a perfectly tailored journey just for you.',
  'faq.title': 'Frequently Asked Questions',
  'faq.error': "Couldn't load FAQs.",
  'faq.tryAgain': 'Try again',
  'carousel.howEarn': 'How did we earn',
  'carousel.star': '4.9 Star',
  'carousel.on': 'On',
  'carousel.error': "Couldn't load reviews.",
  'carousel.tryAgain': 'Try again',
  'carousel.showLess': 'Show less',
  'carousel.readMore': 'Read more',
  'carousel.postedOn': 'Posted on',
  'carousel.prev': 'Previous review',
  'carousel.next': 'Next review',
  'tours.heroAlt': 'Tour packages - Explore Vietnam',
  'intro.videoTitle': 'Introduction video about Vietnam',
};